import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['showModal', 'salesforceModal']

  connect() {
    this.showModal();
  }

  showModal() {
    if(this.hasShowModalTarget) {
      $('.application-modal').modal('show');
    }

    if(this.hasSalesforceModalTarget) {
      $('#integrationsalesforce').modal('show');
    }
  }
}
